<div class="timeline" *ngIf="orderStatuses">
    <div class="timeline-track">
        <div *ngFor="let status of orderStatuses; let i = index" class="timeline-item">
            <div class="timeline-label">{{ status.status }}</div>
            <div class="timeline-node" [ngClass]="status.color">
                @if (status.color === 'green') {
                    <mat-icon class="tick-icon">check</mat-icon>
                } @else {
                    @if (status.status === OrderStatus.Ordered) {
                        <mat-icon class="tick-icon">receipt_long</mat-icon>
                    } @else if (status.status === OrderStatus.Packed) {
                        <mat-icon class="tick-icon">inventory_2</mat-icon>
                    } @else if (status.status === OrderStatus.Dispatched) {
                        <mat-icon class="tick-icon">local_shipping</mat-icon>
                    } @else if (status.status === OrderStatus.Delivered) {
                        <mat-icon class="tick-icon">home</mat-icon>
                    } @else if (status.status === OrderStatus.ExchangeInitiated) {
                        <mat-icon class="tick-icon">autorenew</mat-icon>
                    } @else if (status.status === OrderStatus.ExchangePacked) {
                        <mat-icon class="tick-icon">inventory</mat-icon>
                    } @else if (status.status === OrderStatus.ExchangeDispatched) {
                        <mat-icon class="tick-icon">flight_takeoff</mat-icon>
                    } @else if (status.status === OrderStatus.Exchanged) {
                        <mat-icon class="tick-icon">home</mat-icon>
                    } @else if (status.status === OrderStatus.ReturnInitiated) {
                        <mat-icon class="tick-icon">replay</mat-icon>
                    } @else if (status.status === OrderStatus.PickupScheduled) {
                        <mat-icon class="tick-icon">pending_actions</mat-icon>
                    } @else if (status.status === OrderStatus.Returned) {
                        <mat-icon class="tick-icon">home</mat-icon>
                    }
                }
            </div>
            <div
                class="timeline-line"
                *ngIf="i < orderStatuses.length - 1"
                [ngClass]="orderStatuses[i + 1].color"
            ></div>
            <div class="timeline-date">{{ status.time | date: "d/MM/yyyy hh:mm a" }}</div>
        </div>
    </div>
</div>
